import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    save_changes_button_main_screen_text: {
      id: 'save_changes_button_main_screen_text',
      defaultMessage: "Save changes",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/SaveChangeButtonPopup/Messages.js